// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"685":"f75f27e4","787":"ad3bb5de"}[chunkId] + ".chunk.js";
};